<template>
  <div v-if="featuredOrganizations.length > 0">
    <div class="mt-5 mb-10">
      <div class="container">
        <h1 class="page-header">Featured Projects</h1>
        <flickity
          ref="flickity"
          :options="flickityOptions"
          class="flickity-viewport-visible mb-10"
        >
          <organization-featured
            class="carousel-cell"
            :item="item"
            v-for="item in featuredOrganizations"
            :key="item.id"
          />
        </flickity>
      </div>
    </div>
  </div>
</template>
<script>
import OrganizationFeatured from "./OrganizationFeatured";
import Flickity from "vue-flickity";
export default {
  components: {
    OrganizationFeatured,
    Flickity,
  },
  data() {
    return {
      featuredOrganizations: false,
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: true,
        autoPlay: true,
        cellAlign: "left",
        imagesLoaded: true,
        wrapAround: true,
        lazyLoad: true,
      },
    };
  },
  mounted() {
    this.getFeatured();
  },
  watch: {
    "$store.state.country": function () {
      this.getFeatured();
    },
  },
  methods: {
    getFeatured() {
      this.featuredOrganizations = false;
      let self = this;
      this.axios
        .get(
          window.API_URL + "organizations/featured/" + this.$store.state.country
        )
        .then(function (response) {
          self.featuredOrganizations = response.data;
        })
        .catch(function (error) {});
    },
  },
};
</script>
<style lang="scss">
.carousel-cell {
  width: 100%;
  margin-right: 30px;
}
@media screen and (max-width: 768px) {
  .carousel-cell {
    width: 100%;
  }
}
</style>